import React from 'react'

import {
  Popover,
  PopoverHandler,
  PopoverContent,
  Button,
} from "@material-tailwind/react";
import AIcon from './AIcon';

export default function APopover({ v }) {
  return (
    <div className={`${v.className} `}>


      <Popover className="mb-5" placement="bottom"
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0, y: 25 },
        }}
      >
        <PopoverHandler>
          <Button variant={v.variant} className={`btn1 px-4 py-0.5 !bg-opacity-20  ${v.btn}`}>
            <AIcon name="ellipsis-horizontal-outline" className={`text-main-color text-lg ${v.iconCss}`} />
          </Button>
        </PopoverHandler>
        <PopoverContent className=" relative  max-w-[50rem] min-w-[14rem] p-0.5  !border !border-main-color rounded-md">
       
          {v.data}

          {/*   <div className=' absolute -top-5 left-[50%] mx-auto h-0 w-0 border-r-[20px] border-b-[20px] border-l-[20px] border-solid border-r-transparent border-l-transparent border-b-main-color'></div> */}
        </PopoverContent>
      </Popover>
    </div>
  );
}